import { render, staticRenderFns } from "./SortingOptionList.vue?vue&type=template&id=53bf288a&scoped=true"
import script from "./SortingOptionList.vue?vue&type=script&lang=js"
export * from "./SortingOptionList.vue?vue&type=script&lang=js"
import style0 from "./SortingOptionList.vue?vue&type=style&index=0&id=53bf288a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf288a",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fsorting-option-list%2FSortingOptionList.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports